interface SkillsItemProps {
  Icon: string;
  Name: string;
  XP: string;
}

function SkillsItem({ Icon, Name, XP }: SkillsItemProps) {
  return (
    <div className="Skills-Item">
      <div className="Skills-Item-Left">
        <img className="Skills-Item-Icon" src={Icon} />
      </div>
      <div className="Skills-Item-Right">
        <div className="Skills-Item-Text">{Name}</div>
        <div className="Skills-Item-XPBar">
          <div style={{ width: XP }} className="Skills-Item-XPBar-Inner" />
        </div>
      </div>
    </div>
  );
}

export default SkillsItem;
